import type { Question, AnswerValue } from '../types';
import SectionQuestionList from './SectionQuestionList';

interface SectionReviewOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  questions: Question[];
  answers: Record<string, AnswerValue>;
  onAnswer: (questionId: string, value: AnswerValue) => void;
  sectionLabel: string;
  sectionEmoji: string;
}

export default function SectionReviewOverlay({
  isOpen,
  onClose,
  questions,
  answers,
  onAnswer,
  sectionLabel,
  sectionEmoji,
}: SectionReviewOverlayProps) {
  if (!isOpen) return null;

  const answeredCount = questions.filter((q) => q.id in answers).length;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Bottom sheet */}
      <div className="relative w-full max-w-lg rounded-t-2xl bg-purple-card border-t border-x border-white/10 shadow-2xl max-h-[85vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10 flex-shrink-0">
          <div className="flex items-center gap-2">
            <span className="text-lg">{sectionEmoji}</span>
            <span className="font-semibold text-white">
              {sectionLabel}
            </span>
            <span className="text-xs text-slate-400">
              {answeredCount}/{questions.length}
            </span>
          </div>
          <button
            onClick={onClose}
            className="px-3 py-1.5 text-sm font-medium text-primary-500 hover:text-primary-400 transition-colors"
          >
            Done
          </button>
        </div>

        {/* Scrollable question list */}
        <div className="overflow-y-auto flex-1 p-4">
          <SectionQuestionList
            questions={questions}
            answers={answers}
            onAnswer={onAnswer}
          />
        </div>
      </div>
    </div>
  );
}
